exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".codeTable{font-size:.9em}.codeTable .table{table-layout:fixed}.codeTable .table td,.codeTable .table th{vertical-align:middle;overflow-wrap:break-word}.codeTable .table .success{color:rgba(19,128,0,.7607843137)}.codeTable .table .fail{color:rgba(255,0,0,.664)}.codeTable .table .codeStatusHeader,.codeTable .table .nameHeader{width:20%}.codeTable .table .codeHeader,.codeTable .table .onboardingStatusHeader{width:16%}.codeTable .table .emailHeader{width:28%}.codeTable .table .noPadding{padding:0}.spinnerContainer{padding-left:7em;padding-top:1em}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader!./~/sass-loader/dist/cjs.js!./assets/sass/users/admins/code_table_preference.scss
// module id = 1420
// module chunks = 0